import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

//Include Both Helper File with needed methods
import { formatQueryParams } from "helpers/format";
import redeemCodeApi from "api/redeemCodeApi";

export const getRedeemCodeUsageList = createAsyncThunk(
  "RedeemCodeUsage",
  async (params: any = {}) => {
    try {
      const response = await redeemCodeApi.getRedeemCodeList(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);
